import { Link } from "react-router-dom";
import { PRICING, DISCLOSURE } from "../config";
import SubscriptionPromo from "../components/SubscriptionPromo";

export default function Pricing() {
  return (
    <main className="shell inner">
      <p className="eyebrow">TRANSPARENT ESTIMATES</p>
      <h1 className="page-title">Alteration Pricing</h1>
      <p className="lead darklead">A useful guide to our most commonly requested tailoring services. Every garment receives individual attention.</p>
      <div className="pricing-grid">
        {PRICING.map((g) => (
          <section className="price-card" key={g.group} data-testid={`price-card-${g.group.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
            <h2>{g.group}</h2>
            {g.items.map(([name, price]) => (
              <div className="price-row" key={name}><span>{name}</span><strong>{price}</strong></div>
            ))}
          </section>
        ))}
      </div>
      <aside className="disclosure" data-testid="pricing-disclosure">
        <strong>Important pricing disclosure</strong>
        <p>{DISCLOSURE}</p>
      </aside>
      <div className="actions">
        <Link className="button dark" to="/booking" data-testid="pricing-book-btn">Book a Private Fitting</Link>
      </div>
      <div className="section"><SubscriptionPromo compact /></div>
    </main>
  );
}
